import {SET_FAQ} from "./mutation_types";
import {SET_ERROR, SET_LOADING} from "../eventManagement/mutation_types";


export default {
   [SET_FAQ](state,response){
       state.faq = response.data;
   },
    [SET_ERROR](state, error) {
        state.error = error;
    },

    [SET_LOADING](state, loading) {
        state.loading = loading;
    },
}